import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "@ui5/webcomponents/dist/Bar.js";
import "@ui5/webcomponents/dist/Button.js";

const mainMenuItems = [
  { roles: ["1", "9"], path: "/create-mass", label: "Mass Upload" },
  { roles: ["1", "9"], path: "/create-manual", label: "Manual Input" },
  { roles: ["1", "2", "3", "9"], path: "/view-records", label: "View Records" },
  { roles: ["1", "2", "9"], path: "/monitor-emergency", label: "Monitor Emergency" }
];
const manageMenuItems = [
  { roles: ["1", "9"], path: "/manage-users", label: "Manage Users" },
  { roles: ["1", "9"], path: "/activate-client", label: "Activate Client" },
  { roles: ["1", "9"], path: "/manage-organization", label: "Manage Organization" } // <-- Added
];

const MenuBar = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("userRole");
  console.log("Current role:", role);
  const [manageDropdownOpen, setManageDropdownOpen] = useState(false);

  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest(".manage-dropdown")) {
        setManageDropdownOpen(false);
      }
    };

    if (manageDropdownOpen) {
      document.addEventListener("pointerdown", handleClick); // Use pointerdown for better compatibility
    }

    return () => document.removeEventListener("pointerdown", handleClick);
  }, [manageDropdownOpen]);

  console.log("Dropdown open state:", manageDropdownOpen);

  return (
    <ui5-bar design="Header" style={{ marginBottom: "2rem", width: "100%" }}>
      <div slot="startContent" style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
        Emergency Monitoring System
      </div>
      <div slot="endContent" style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
        {mainMenuItems
          .filter(item => item.roles.includes(role))
          .map((item, idx) => (
            <ui5-button key={idx} design="Transparent" onClick={() => navigate(item.path)}>
              {item.label}
            </ui5-button>
          ))}
        {manageMenuItems.some(item => item.roles.includes(role)) && (
          <div className="manage-dropdown" style={{ position: "relative" }}>
            <ui5-button
              design="Transparent"
              onClick={(e) => {
                e.stopPropagation(); // prevent event bubbling
                setManageDropdownOpen((open) => !open);
              }}
              aria-haspopup="true"
              aria-expanded={manageDropdownOpen}
            >
              Manage
            </ui5-button>
            {manageDropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "100%",
                  background: "#fff",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  borderRadius: "6px",
                  minWidth: "180px",
                  zIndex: 1000,
                  marginTop: "4px",
                  padding: "0.5rem 0"
                }}
              >
                {manageMenuItems
                  .filter(item => item.roles.includes(role))
                  .map((item, idx) => (
                    <div
                      key={idx}
                      onClick={() => {
                        setManageDropdownOpen(false);
                        navigate(item.path);
                      }}
                      style={{
                        padding: "0.75rem 1.25rem",
                        cursor: "pointer",
                        fontSize: "1rem",
                        color: "#222",
                        whiteSpace: "nowrap",
                        transition: "background 0.2s",
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = "#f0f4f8"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                    >
                      {item.label}
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}
      </div>
    </ui5-bar>
  );
};

export default MenuBar;
